import { render } from "./PropertyFormSection.vue?vue&type=template&id=73498c26&scoped=true&ts=true"
import script from "./PropertyFormSection.vue?vue&type=script&lang=ts"
export * from "./PropertyFormSection.vue?vue&type=script&lang=ts"

import "./PropertyFormSection.vue?vue&type=style&index=0&id=73498c26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73498c26"]])

export default __exports__